export { default } from './ForecastGraphSlider';
